"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileReference = void 0;
var lodash_isempty_1 = __importDefault(require("lodash.isempty"));
function getFileReference(primaryRefs, authRefs, objectRefs) {
    // we *should* have primaryRefs - grab all of them
    if (primaryRefs && !(0, lodash_isempty_1.default)(primaryRefs)) {
        return primaryRefs;
    }
    // if we dont have primaryRefs, check for 'account' in authRefs/objectRefs
    if (authRefs === null || authRefs === void 0 ? void 0 : authRefs.account) {
        return { account: authRefs.account };
    }
    if (objectRefs === null || objectRefs === void 0 ? void 0 : objectRefs.account) {
        return { account: objectRefs.account };
    }
    // if we cant find 'account', check for 'client'
    if (authRefs === null || authRefs === void 0 ? void 0 : authRefs.client) {
        return { client: authRefs.client };
    }
    if (objectRefs === null || objectRefs === void 0 ? void 0 : objectRefs.client) {
        return { client: objectRefs.client };
    }
    return undefined;
}
exports.getFileReference = getFileReference;
